import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import {
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
  STATE_IDENTIFIER,
} from "./constants";

const {
  ROLES,
  SELECTED_ROLE,
  USERS_MANAGEMENT,
  STEP_ONE,
  REQUEST_STATE,
  SELECTED_USERS,
  COMPACTED_USERS,
  STEP_TWO,
  USER_DETAIL,
  SOCIETY_VALIDATION,
  USERS,
  OFFICES,
  COMPANIES,
  ADD_USER,
  ALREADY_EXISTING_FISCAL_CODE,
  FIELD_VISIBILITY,
  BUTTONS,
  MANAGERS,
  REFERRALS,
  ORGANIZATIONAL_UNITS,
  OU_SELECTED_ROLES,
  COMBO_OPTIONS,
  CLUSTER,
  CONTRACT_TYPOLOGY,
  FTE,
  PRESENCE,
  REACTIVATE_RENEW_ADMIN_BODY,
  ADD_USER_RESPONSE_STATE,
  ATTACHMENTS,
  ADMIN_LETTERS,
  REACTIVATE_RENEW_MASSIVE_BODY,
  USER_TYPES_THAT_CAN_BE_CREATED,
  MANIPOLATED_OU,
  FAILED_OPERATIONS,
  USERS_WITH_SAME_FISCAL_CODE_MANAGER,
} = STATE_IDENTIFIER;

export default {
  [ROLES]: {
    [LIST_IDENTIFIER]: [],
    [LOADER_IDENTIFIER]: false,
    [REQUEST_STATE]: IResponseState.PENDING,
  },
  [OFFICES]: {
    [LIST_IDENTIFIER]: [],
    [LOADER_IDENTIFIER]: false,
  },
  [MANAGERS]: {
    [LIST_IDENTIFIER]: [],
    [LOADER_IDENTIFIER]: false,
  },
  [REFERRALS]: {
    [LIST_IDENTIFIER]: [],
    [LOADER_IDENTIFIER]: false,
  },
  [ORGANIZATIONAL_UNITS]: {
    [LIST_IDENTIFIER]: [],
    [LOADER_IDENTIFIER]: false,
  },
  [OU_SELECTED_ROLES]: {
    [LIST_IDENTIFIER]: [],
    [LOADER_IDENTIFIER]: false,
  },
  [SELECTED_ROLE]: [],
  [USERS_MANAGEMENT]: {
    [MANIPOLATED_OU]: [],
    [STEP_ONE]: {
      [LIST_IDENTIFIER]: [],
      [REQUEST_STATE]: IResponseState.PENDING,
      [FAILED_OPERATIONS]: [],
      [COMPACTED_USERS]: [],
      [LOADER_IDENTIFIER]: false,
      [SELECTED_USERS]: [],
      [REACTIVATE_RENEW_ADMIN_BODY]: [],
      [REACTIVATE_RENEW_MASSIVE_BODY]: [],
      [ATTACHMENTS]: {
        [LIST_IDENTIFIER]: [],
        [LOADER_IDENTIFIER]: false,
      },
      [ADMIN_LETTERS]: {
        [LIST_IDENTIFIER]: [],
        [LOADER_IDENTIFIER]: false,
      },
    },
    [STEP_TWO]: {
      [USER_DETAIL]: [],
      [REQUEST_STATE]: IResponseState.PENDING,
    },
    [ADD_USER]: {
      [ALREADY_EXISTING_FISCAL_CODE]: false,
      [USERS_WITH_SAME_FISCAL_CODE_MANAGER]: [],
      [REQUEST_STATE]: IResponseState.PENDING,
      [ADD_USER_RESPONSE_STATE]: IResponseState.PENDING,
      [LOADER_IDENTIFIER]: false,
      [USER_TYPES_THAT_CAN_BE_CREATED]: [],
    },
    [FIELD_VISIBILITY]: { [LIST_IDENTIFIER]: [], [LOADER_IDENTIFIER]: false },
    [BUTTONS]: { [LIST_IDENTIFIER]: [], [LOADER_IDENTIFIER]: false },
  },
  [SOCIETY_VALIDATION]: {
    [USERS]: {
      [LIST_IDENTIFIER]: [],
      [COMPACTED_USERS]: [],
      [LOADER_IDENTIFIER]: false,
      [SELECTED_USERS]: [],
      [REQUEST_STATE]: IResponseState.PENDING,
    },
  },
  [COMPANIES]: {
    [LIST_IDENTIFIER]: [],
    [LOADER_IDENTIFIER]: false,
  },
  [COMBO_OPTIONS]: {
    [CLUSTER]: [],
    [CONTRACT_TYPOLOGY]: [],
    [FTE]: [],
    [PRESENCE]: [],
  },
  [REQUEST_STATE]: IResponseState.PENDING,
};
